export default {
  online: 'Online',
  offline: 'Offline',
  deviceSn: 'Device SN:',
  deviceType: 'Device Type:',
  viewDetail: 'View Details',
  edit: 'Edit',
  editTitle: 'Edit Robot Info',
  cancel: 'Cancel',
  confirm: 'Confirm',
  fieldId: 'ID',
  fieldSn: 'Device SN',
  fieldStatus: 'Status',
  fieldAlias: 'Alias',
  fieldAliasEn: 'Alias (EN)',
  fieldDeviceType: 'Device Type',
  fieldRobotType: 'Robot Type',
  placeholderSn: 'Enter device SN',
  placeholderStatus: 'Enter status',
  placeholderAlias: 'Enter alias',
  placeholderAliasEn: 'Enter English alias',
  placeholderDeviceType: 'Enter device type',
  placeholderRobotType: 'Enter robot type',
  ruleSn: 'Please enter device SN',
  ruleStatus: 'Please enter status',
  ruleAlias: 'Please enter alias',
  ruleAliasEn: 'Please enter English alias',
  ruleDeviceType: 'Please enter device type',
  ruleRobotType: 'Please enter robot type',
  successUpdate: 'Updated successfully',
  failUpdate: 'Update failed',
  empty: 'No devices found',
  backToList: 'Back to Device List',
  detailComingSoon: 'Detail page for this device type is under development',
  unsupportedType: 'Detail view is not available for this device type',
  detailTitleDance: 'Dance Robot',
  detailTitleComprehensive: 'Comprehensive Robot',
  detailTitleTern: 'Huashu Robot',
}
